export default [
  {
    path: '/my',
    meta: {
      title: '我的'
    },
    component: () => import('Pages/my/index')
  },
  {
    path: '/about-us',
    component: () => import('Pages/my/about-us')
  },
  {
    path: '/use-clauses',
    component: () => import('Pages/my/use-clauses')
  },
  {
    path: '/expense-calendar',
    component: () => import('../pages/my/expense-calendar')
  },
  {
    path: '/about-prep',
    component: () => import('Pages/my/about-prep')
  },
  {
    path: '/my/pat',
    meta: {
      title: '常用就诊人'
    },
    component: () => import('Pages/my/pat')
  },
  {
    path: '/my/pat/add',
    // meta: {
    //   title: '添加就诊人'
    // },
    component: () => import('Pages/my/pat/add')
  },

  {
    path: '/my/editContactInfo',
    component: () => import('Pages/my/pat/editContact')
  },

  /**
   * 修改手机号
   * query
   * **** type [pat,commpat]
   * **** step [1,2]
   * **** cid
   * **** captcha
   */
  {
    path: '/my/pat/mobile',
    component: () => import('Pages/my/pat/mobile')
  },
  /**
   * 网络诊间预约记录
   */
  {
    path: '/my/order/list',
    component: () => import('Pages/my/order/order-list')
  },
  /**
   * 网络诊间预约详情页
   */
  {
    path: '/my/order/detail',
    component: () => import('Pages/my/order/order-detail')
  },
  /**
   * 我的挂号列表
   */
  {
    path: '/my/book/list',
    component: () => import('Pages/my/book/book-list')
  },
  /**
   * 我的挂号详情
   * **** hzid 患者编号
   * **** orgid 医院编号
   * **** orderid 订单编号
   **/
  {
    path: '/my/book/detail',
    component: () => import('Pages/my/book/book-detail.vue')
  },
  /**
   * query
   * **** id
   * cache
   * **** dataCache
   */
  {
    path: '/my/detail',
    meta: {
      title: '个人资料'
    },
    component: () => import('Pages/my/detail')
  },
  {
    path: '/my/edit',
    component: () => import('Pages/my/edit')
  },
  {
    path: '/my/archives',
    meta: {
      title: '健康档案'
    },
    component: () => import('Pages/my/archives')
  },
  /**
   * 添加/编辑 健康档案
   * query
   * **** type
   * **** value
   */
  {
    path: '/my/archives/add',
    component: () => import('Pages/my/archives/add')
  },
  /**
   * 添加 病历
   * query
   * **** type
   * **** value
   */
  {
    path: '/my/archives/medical/add',
    component: () => import('Pages/my/archives/medical/save')
  },
  /**
   * 编辑 病历
   * query
   * **** id
   * cache
   * **** medicalDetail
   */
  {
    path: '/my/archives/medical/edit',
    component: () => import('Pages/my/archives/medical/save')
  },
  /**
   * 编辑 病历
   * query
   * **** id
   * cache
   * **** medicalDetail
   */
  {
    path: '/my/about',
    meta: {
      title: '账户相关'
    },
    component: () => import('Pages/my/about')
  },
  {
    path: '/plus/apply',
    component: () => import('Pages/my/plus')
  },
  {
    path: '/plus/detail/:id',
    component: () => import('Pages/my/plus-detail')
  },
  {
    path: '/my/plus-list',
    meta: {
      title: '我的加号'
    },
    component: () => import('Pages/my/plus-list')
  },
  /**
   * 我的医生
   */
  {
    path: '/my/doc',
    meta: {
      title: '我的医生'
    },
    redirect: '/my/doc/follow',
    children: [
      {
        path: 'follow',
        component: () => import('Pages/my/doc/follow')
      },
      {
        path: 'msg',
        component: () => import('Pages/my/doc/msg')
      }
    ],
    component: () => import('Pages/my/doc')
  },
  {
    path:'/fp/index',
    component: () => import('Pages/my/fp/index')
  },
  {
    path:'/fp/list',
    component: () => import('Pages/my/fp/list')
  },
  {
    path:'/fp/look',
    component: () => import('Pages/my/fp/look')
  },
  {
    path:'/fp/myList',
    component: () => import('Pages/my/fp/myList')
  },
  {
    path: "/my/phone/index",
    meta: {
      title: "修改预留手机号"
    },
    component: () => import("Pages/my/phone/index")
  },
  {
    path: "/my/phone/oldPhone",
    meta: {
      title: "修改预留手机号"
    },
    component: () => import("Pages/my/phone/oldPhone")
  },
  {
    path: "/my/phone/newPhone",
    meta: {
      title: "修改预留手机号"
    },
    component: () => import("Pages/my/phone/newPhone")
  },
  {
    path: "/my/phone/succeed",
    meta: {
      title: "修改成功"
    },
    component: () => import("Pages/my/phone/succeed")
  },
  {
    path: "/my/phone/index",
    meta: {
      title: "修改预留手机号"
    },
    component: () => import("Pages/my/phone/index")
  },
  {
    path: "/myBl/list",
    meta: {
      title: "电子病历"
    },
    component: () => import("Pages/my/dzblList")
  }
]



// WEBPACK FOOTER //
// ./src/router/my.js